var _path, _g, _path2, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _g13, _path82, _path83, _g14, _g15, _path84, _path85, _path86, _path87, _path88, _path89, _g16, _g17, _g18, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotConnectedPlug(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 236,
    viewBox: "0 0 224 236",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.877 43.5469C123.013 46.2682 130.264 56.6681 140.972 60.7602C154.433 65.9039 173.759 58.8971 182.341 70.4728C190.597 81.6089 181.899 97.7589 178.334 111.155C175.43 122.067 168.876 131.033 163.572 141.002C158.063 151.355 156.099 164.375 146.46 171.055C136.688 177.828 123.763 177.114 111.877 176.83C100.199 176.55 88.766 174.479 78.2366 169.422C67.1642 164.103 55.96 157.623 49.7838 147.005C43.6012 136.376 45.5332 123.394 44.3442 111.155C43.0273 97.6014 37.01 83.5491 42.4036 71.045C47.8927 58.3195 60.3367 49.3053 73.2229 44.2048C85.4126 39.38 99.1416 40.4349 111.877 43.5469Z",
    fill: "var(--color-primary-active)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_60920_3009)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_60920_3009)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_di_60920_3009)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.842 148.701C137.842 150.523 136.365 152 134.543 152L72.2988 152C70.4769 152 69.0001 150.523 69.0001 148.701L69.0001 74.515C69.0001 72.6932 70.4769 71.2163 72.2988 71.2163L134.543 71.2163C136.365 71.2163 137.842 72.6932 137.842 74.515L137.842 148.701Z",
    fill: "var(--color-primary-60)"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6846 90.4914C81.6846 84.9685 86.1617 80.4914 91.6846 80.4914H115.122C120.645 80.4914 125.122 84.9685 125.122 90.4914V135.419C125.122 140.942 120.645 145.419 115.122 145.419H91.6846C86.1617 145.419 81.6846 140.942 81.6846 135.419V90.4914Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_60920_3009)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_60920_3009)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.7646 89.4056C85.7646 89.059 86.0456 88.778 86.3922 88.778H119.773C120.119 88.778 120.4 89.059 120.4 89.4056C120.4 89.7521 120.119 90.0331 119.773 90.0331H86.3922C86.0456 90.0331 85.7646 89.7521 85.7646 89.4056Z",
    fill: "#E5EBFF"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_60920_3009)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_60920_3009)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.7646 94.7286C85.7646 94.382 86.0456 94.1011 86.3922 94.1011H119.773C120.119 94.1011 120.4 94.382 120.4 94.7286C120.4 95.0752 120.119 95.3562 119.773 95.3562H86.3922C86.0456 95.3562 85.7646 95.0752 85.7646 94.7286Z",
    fill: "#E5EBFF"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_i_60920_3009)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_60920_3009)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.7646 99.4602C85.7646 99.1136 86.0456 98.8326 86.3922 98.8326H119.773C120.119 98.8326 120.4 99.1136 120.4 99.4602C120.4 99.8068 120.119 100.088 119.773 100.088H86.3922C86.0456 100.088 85.7646 99.8068 85.7646 99.4602Z",
    fill: "#E5EBFF"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_i_60920_3009)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_d_60920_3009)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.7646 104.192C85.7646 103.845 86.0456 103.564 86.3922 103.564H119.773C120.119 103.564 120.4 103.845 120.4 104.192C120.4 104.538 120.119 104.819 119.773 104.819H86.3922C86.0456 104.819 85.7646 104.538 85.7646 104.192Z",
    fill: "#E5EBFF"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_i_60920_3009)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_d_60920_3009)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.7646 108.923C85.7646 108.577 86.0456 108.296 86.3922 108.296H119.773C120.119 108.296 120.4 108.577 120.4 108.923C120.4 109.27 120.119 109.551 119.773 109.551H86.3922C86.0456 109.551 85.7646 109.27 85.7646 108.923Z",
    fill: "#E5EBFF"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_i_60920_3009)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_d_60920_3009)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.7646 113.655C85.7646 113.308 86.0456 113.027 86.3922 113.027H119.773C120.119 113.027 120.4 113.308 120.4 113.655C120.4 114.002 120.119 114.282 119.773 114.282H86.3922C86.0456 114.282 85.7646 114.002 85.7646 113.655Z",
    fill: "#E5EBFF"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_i_60920_3009)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_d_60920_3009)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.7646 118.387C85.7646 118.04 86.0456 117.759 86.3922 117.759H119.773C120.119 117.759 120.4 118.04 120.4 118.387C120.4 118.733 120.119 119.014 119.773 119.014H86.3922C86.0456 119.014 85.7646 118.733 85.7646 118.387Z",
    fill: "#E5EBFF"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_i_60920_3009)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_d_60920_3009)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.7646 123.118C85.7646 122.772 86.0456 122.491 86.3922 122.491H119.773C120.119 122.491 120.4 122.772 120.4 123.118C120.4 123.465 120.119 123.746 119.773 123.746H86.3922C86.0456 123.746 85.7646 123.465 85.7646 123.118Z",
    fill: "#E5EBFF"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_i_60920_3009)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_d_60920_3009)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.7646 127.85C85.7646 127.503 86.0456 127.222 86.3922 127.222H119.773C120.119 127.222 120.4 127.503 120.4 127.85C120.4 128.196 120.119 128.477 119.773 128.477H86.3922C86.0456 128.477 85.7646 128.196 85.7646 127.85Z",
    fill: "#E5EBFF"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_i_60920_3009)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter22_d_60920_3009)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.7646 132.581C85.7646 132.235 86.0456 131.954 86.3922 131.954H119.773C120.119 131.954 120.4 132.235 120.4 132.581C120.4 132.928 120.119 133.209 119.773 133.209H86.3922C86.0456 133.209 85.7646 132.928 85.7646 132.581Z",
    fill: "#E5EBFF"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter23_i_60920_3009)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter24_d_60920_3009)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.7646 137.017C85.7646 136.671 86.0456 136.39 86.3922 136.39H109.116C109.462 136.39 109.743 136.671 109.743 137.017C109.743 137.364 109.462 137.645 109.116 137.645H86.3922C86.0456 137.645 85.7646 137.364 85.7646 137.017Z",
    fill: "#E5EBFF"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M148.884 125.503C148.914 126.705 152.934 128.585 138.799 128.942C124.665 129.299 113.235 128.614 113.27 127.412C113.304 126.21 124.728 123.143 138.862 122.786C152.996 122.429 148.806 122.255 148.884 125.503Z",
    fill: "#FEFEFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M148.403 125.532C148.432 126.718 152.384 128.571 138.45 128.923C124.516 129.275 113.249 128.599 113.282 127.415C113.317 126.229 124.577 123.208 138.511 122.856C152.445 122.504 148.325 122.332 148.402 125.532H148.403Z",
    fill: "#FDFDFD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    d: "M147.922 125.563C147.951 126.73 151.834 128.557 138.101 128.904C124.368 129.251 113.262 128.585 113.296 127.418C113.329 126.25 124.429 123.273 138.162 122.925C151.895 122.578 147.846 122.41 147.922 125.563Z",
    fill: "#FCFCFC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M147.442 125.592C147.47 126.743 151.285 128.542 137.752 128.885C124.22 129.227 113.276 128.571 113.31 127.42C113.343 126.269 124.28 123.336 137.812 122.994C151.345 122.652 147.367 122.486 147.442 125.591V125.592Z",
    fill: "#FBFBFB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M146.962 125.623C146.99 126.757 150.736 128.529 137.404 128.866C124.072 129.203 113.291 128.557 113.323 127.424C113.356 126.289 124.13 123.402 137.463 123.065C150.795 122.727 146.888 122.565 146.962 125.623Z",
    fill: "#FAFAFA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M146.48 125.653C146.508 126.77 150.185 128.515 137.054 128.847C123.923 129.18 113.304 128.543 113.335 127.427C113.367 126.31 123.98 123.467 137.111 123.134C150.242 122.802 146.407 122.642 146.48 125.653Z",
    fill: "#F9F9F9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M146 125.682C146.027 126.782 149.636 128.5 136.706 128.828C123.775 129.155 113.317 128.529 113.349 127.429C113.38 126.328 123.831 123.53 136.762 123.203C149.692 122.875 145.928 122.719 146 125.681V125.682Z",
    fill: "#F8F8F9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M145.52 125.713C145.547 126.795 149.087 128.486 136.357 128.809C123.628 129.132 113.332 128.515 113.363 127.432C113.394 126.35 123.683 123.596 136.413 123.274C149.143 122.951 145.45 122.798 145.521 125.713H145.52Z",
    fill: "#F7F7F8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M145.039 125.743C145.064 126.809 148.537 128.473 136.008 128.79C123.478 129.108 113.346 128.501 113.376 127.435C113.407 126.37 123.533 123.661 136.062 123.343C148.592 123.025 144.969 122.875 145.039 125.742V125.743Z",
    fill: "#F6F6F7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M144.558 125.773C144.583 126.822 147.987 128.458 135.659 128.771C123.329 129.084 113.359 128.486 113.389 127.438C113.418 126.389 123.383 123.726 135.712 123.413C148.042 123.1 144.49 122.953 144.558 125.773Z",
    fill: "#F5F5F6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M144.078 125.803C144.102 126.834 147.439 128.444 135.311 128.752C123.182 129.06 113.374 128.473 113.402 127.441C113.432 126.41 123.234 123.79 135.363 123.483C147.492 123.175 144.011 123.031 144.078 125.803Z",
    fill: "#F4F4F5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M143.597 125.833C143.621 126.848 146.889 128.431 134.961 128.733C123.033 129.036 113.387 128.459 113.415 127.444C113.444 126.429 123.084 123.855 135.012 123.553C146.941 123.25 143.531 123.109 143.597 125.833Z",
    fill: "#F3F4F4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M143.116 125.863C143.14 126.86 146.34 128.416 134.612 128.714C122.884 129.012 113.4 128.444 113.429 127.447C113.457 126.45 122.935 123.92 134.662 123.623C146.39 123.324 143.051 123.186 143.116 125.863Z",
    fill: "#F2F3F3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M142.635 125.893C142.658 126.874 145.79 128.402 134.263 128.695C122.736 128.988 113.414 128.431 113.441 127.45C113.469 126.47 122.785 123.984 134.312 123.692C145.839 123.399 142.572 123.264 142.636 125.893H142.635Z",
    fill: "#F1F2F2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M142.155 125.924C142.178 126.887 145.241 128.389 133.915 128.677C122.588 128.965 113.429 128.417 113.455 127.454C113.482 126.49 122.636 124.05 133.963 123.763C145.289 123.474 142.093 123.342 142.156 125.925L142.155 125.924Z",
    fill: "#F0F1F1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M141.675 125.953C141.697 126.899 144.692 128.375 133.566 128.657C122.441 128.94 113.442 128.402 113.469 127.456C113.495 126.51 122.487 124.114 133.613 123.831C144.738 123.548 141.613 123.419 141.675 125.953Z",
    fill: "#EFF0F0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M141.194 125.983C141.216 126.913 144.142 128.361 133.216 128.638C122.291 128.916 113.455 128.388 113.481 127.459C113.506 126.529 122.336 124.178 133.261 123.901C144.186 123.623 141.133 123.497 141.193 125.983H141.194Z",
    fill: "#EEEFEF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M140.713 126.014C140.736 126.926 143.593 128.347 132.868 128.62C122.143 128.892 113.47 128.375 113.495 127.463C113.521 126.551 122.189 124.244 132.913 123.971C143.637 123.699 140.654 123.575 140.713 126.014Z",
    fill: "#EDEEEE"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M140.232 126.043C140.254 126.938 143.043 128.333 132.519 128.6C121.995 128.868 113.483 128.36 113.508 127.465C113.532 126.57 122.038 124.309 132.563 124.04C143.087 123.773 140.174 123.652 140.232 126.043Z",
    fill: "#ECEDED"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M139.751 126.074C139.773 126.952 142.493 128.319 132.169 128.582C121.846 128.844 113.496 128.346 113.521 127.468C113.545 126.589 121.888 124.374 132.212 124.11C142.535 123.847 139.693 123.729 139.75 126.073L139.751 126.074Z",
    fill: "#EBECEC"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M139.27 126.104C139.291 126.965 141.944 128.305 131.82 128.563C121.697 128.821 113.51 128.333 113.533 127.472C113.557 126.611 121.738 124.439 131.861 124.18C141.985 123.923 139.214 123.808 139.269 126.104H139.27Z",
    fill: "#EAEBEC"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M138.79 126.133C138.811 126.977 141.395 128.29 131.472 128.543C121.549 128.796 113.524 128.318 113.548 127.474C113.572 126.629 121.59 124.503 131.513 124.249C141.436 123.996 138.736 123.884 138.79 126.133Z",
    fill: "#E9EAEB"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M138.309 126.164C138.33 126.99 140.845 128.277 131.123 128.525C121.4 128.773 113.538 128.304 113.561 127.478C113.583 126.651 121.441 124.569 131.162 124.32C140.884 124.072 138.255 123.963 138.309 126.164Z",
    fill: "#E8E9EA"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M137.828 126.193C137.848 127.003 140.295 128.262 130.773 128.505C121.252 128.748 113.552 128.289 113.573 127.48C113.595 126.67 121.29 124.632 130.812 124.388C140.333 124.145 137.776 124.039 137.828 126.193Z",
    fill: "#E7E8E9"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M137.348 126.223C137.368 127.017 139.746 128.248 130.425 128.486C121.104 128.725 113.565 128.276 113.587 127.482C113.609 126.689 121.141 124.697 130.462 124.459C139.783 124.22 137.297 124.118 137.348 126.223Z",
    fill: "#E6E7E8"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M136.868 126.254C136.887 127.029 139.197 128.234 130.077 128.468C120.956 128.701 113.58 128.262 113.601 127.486C113.621 126.711 120.993 124.763 130.113 124.529C139.233 124.296 136.818 124.196 136.868 126.255V126.254Z",
    fill: "#E5E6E7"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M136.387 126.283C136.406 127.042 138.647 128.22 129.728 128.448C120.808 128.677 113.594 128.247 113.614 127.488C113.635 126.73 120.843 124.827 129.763 124.598C138.683 124.37 136.338 124.274 136.387 126.283Z",
    fill: "#E4E5E6"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M135.906 126.314C135.925 127.055 138.097 128.206 129.378 128.43C120.659 128.653 113.607 128.234 113.627 127.491C113.647 126.75 120.694 124.891 129.413 124.668C138.132 124.444 135.859 124.351 135.906 126.314Z",
    fill: "#E3E4E5"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M135.426 126.344C135.444 127.069 137.548 128.192 129.03 128.411C120.512 128.63 113.621 128.22 113.641 127.495C113.66 126.771 120.545 124.957 129.063 124.738C137.582 124.52 135.38 124.429 135.426 126.344Z",
    fill: "#E2E3E4"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M134.945 126.374C134.963 127.082 136.998 128.178 128.681 128.391C120.363 128.605 113.635 128.205 113.653 127.497C113.672 126.789 120.394 125.021 128.712 124.807C137.03 124.593 134.899 124.506 134.944 126.374H134.945Z",
    fill: "#E1E2E3"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M134.464 126.404C134.481 127.094 136.449 128.164 128.332 128.373C120.214 128.581 113.648 128.191 113.666 127.501C113.684 126.811 120.245 125.086 128.362 124.877C136.479 124.669 134.419 124.584 134.464 126.405V126.404Z",
    fill: "#E0E1E2"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M133.984 126.434C134 127.108 135.9 128.15 127.983 128.354C120.067 128.558 113.663 128.178 113.681 127.504C113.698 126.83 120.096 125.151 128.014 124.947C135.93 124.743 133.941 124.662 133.985 126.434H133.984Z",
    fill: "#DFE0E1"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M133.503 126.464C133.519 127.12 135.35 128.135 127.634 128.334C119.917 128.534 113.676 128.163 113.693 127.506C113.71 126.85 119.947 125.215 127.663 125.016C135.38 124.817 133.461 124.738 133.504 126.464H133.503Z",
    fill: "#DEDFE0"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M133.023 126.494C133.038 127.133 134.801 128.122 127.286 128.316C119.77 128.51 113.69 128.149 113.707 127.51C113.724 126.871 119.798 125.28 127.313 125.086C134.829 124.892 132.981 124.817 133.023 126.494Z",
    fill: "#DEDFE0"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.51,
    d: "M132.541 126.525C132.556 127.147 134.25 128.108 126.935 128.297C119.62 128.486 113.703 128.135 113.719 127.513C113.735 126.89 119.647 125.345 126.962 125.156C134.278 124.967 132.501 124.894 132.541 126.525Z",
    fill: "#DDDEDF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M132.061 126.554C132.075 127.159 133.701 128.093 126.587 128.278C119.472 128.462 113.718 128.121 113.732 127.516C113.748 126.911 119.498 125.41 126.613 125.226C133.728 125.041 132.022 124.973 132.061 126.554Z",
    fill: "#DCDDDE"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M131.581 126.584C131.595 127.173 133.152 128.08 126.239 128.259C119.325 128.438 113.732 128.107 113.747 127.519C113.762 126.93 119.35 125.475 126.264 125.295C133.178 125.116 131.543 125.05 131.581 126.584Z",
    fill: "#DBDCDD"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M131.099 126.615C131.113 127.185 132.603 128.066 125.89 128.24C119.176 128.415 113.745 128.093 113.76 127.522C113.775 126.951 119.2 125.539 125.913 125.366C132.627 125.191 131.063 125.128 131.099 126.616V126.615Z",
    fill: "#DADBDC"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M130.619 126.644C130.633 127.198 132.054 128.051 125.541 128.221C119.028 128.39 113.76 128.079 113.773 127.525C113.787 126.971 119.051 125.604 125.564 125.435C132.077 125.266 130.585 125.206 130.619 126.645V126.644Z",
    fill: "#D9DADB"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.59,
    d: "M130.138 126.675C130.152 127.212 131.505 128.037 125.191 128.202C118.879 128.367 113.772 128.065 113.785 127.528C113.798 126.99 118.901 125.669 125.213 125.505C131.525 125.34 130.104 125.283 130.138 126.676V126.675Z",
    fill: "#D8D9DA"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M129.657 126.704C129.67 127.224 130.955 128.023 124.842 128.183C118.73 128.342 113.786 128.05 113.798 127.53C113.811 127.01 118.75 125.732 124.862 125.574C130.973 125.414 129.623 125.36 129.656 126.704H129.657Z",
    fill: "#D7D8D9"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M129.176 126.734C129.189 127.237 130.405 128.009 124.493 128.164C118.582 128.318 113.799 128.036 113.812 127.533C113.823 127.03 118.601 125.798 124.512 125.644C130.423 125.49 129.144 125.438 129.176 126.735V126.734Z",
    fill: "#D6D7D8"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M128.696 126.765C128.708 127.25 129.856 127.995 124.144 128.145C118.434 128.294 113.813 128.022 113.825 127.536C113.837 127.051 118.452 125.863 124.163 125.714C129.874 125.565 128.666 125.516 128.696 126.765Z",
    fill: "#D5D6D7"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M128.215 126.794C128.227 127.263 129.306 127.98 123.795 128.125C118.285 128.27 113.827 128.007 113.838 127.539C113.849 127.071 118.302 125.927 123.812 125.783C129.322 125.639 128.185 125.593 128.214 126.795L128.215 126.794Z",
    fill: "#D4D5D6"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.66,
    d: "M127.734 126.825C127.746 127.277 128.756 127.967 123.446 128.107C118.136 128.246 113.841 127.993 113.851 127.542C113.861 127.09 118.153 125.992 123.462 125.853C128.772 125.714 127.705 125.672 127.733 126.825H127.734Z",
    fill: "#D3D4D5"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    d: "M127.254 126.855C127.265 127.289 128.207 127.953 123.098 128.088C117.988 128.223 113.854 127.98 113.865 127.545C113.875 127.111 118.004 126.058 123.113 125.923C128.223 125.788 127.228 125.749 127.254 126.855Z",
    fill: "#D2D3D4"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.69,
    d: "M126.774 126.884C126.785 127.302 127.658 127.938 122.749 128.069C117.841 128.198 113.869 127.965 113.879 127.548C113.889 127.13 117.855 126.123 122.764 125.992C127.673 125.863 126.748 125.826 126.774 126.885V126.884Z",
    fill: "#D1D2D3"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M126.292 126.915C126.302 127.315 127.107 127.925 122.399 128.049C117.691 128.174 113.882 127.95 113.891 127.55C113.899 127.15 117.705 126.186 122.412 126.061C127.12 125.936 126.266 125.903 126.292 126.914V126.915Z",
    fill: "#D0D1D3"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.72,
    d: "M125.812 126.945C125.822 127.329 126.558 127.911 122.051 128.031C117.543 128.15 113.896 127.936 113.904 127.553C113.912 127.17 117.555 126.251 122.063 126.13C126.57 126.011 125.787 125.98 125.812 126.944V126.945Z",
    fill: "#CFD0D2"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M125.332 126.975C125.342 127.341 126.01 127.896 121.703 128.011C117.396 128.126 113.911 127.922 113.918 127.556C113.926 127.189 117.407 126.316 121.713 126.2C126.02 126.085 125.309 126.058 125.332 126.974V126.975Z",
    fill: "#CECFD1"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M124.851 127.005C124.86 127.354 125.46 127.882 121.353 127.992C117.247 128.102 113.924 127.908 113.932 127.559C113.939 127.21 117.257 126.38 121.364 126.271C125.47 126.161 124.83 126.136 124.852 127.005H124.851Z",
    fill: "#CDCED0"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M124.37 127.035C124.379 127.368 124.91 127.869 121.004 127.974C117.099 128.078 113.937 127.894 113.944 127.563C113.951 127.23 117.107 126.446 121.013 126.341C124.919 126.236 124.349 126.215 124.37 127.035Z",
    fill: "#CCCDCF"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    d: "M123.89 127.065C123.898 127.38 124.361 127.854 120.656 127.954C116.951 128.054 113.952 127.88 113.958 127.565C113.964 127.25 116.959 126.51 120.664 126.41C124.369 126.31 123.87 126.291 123.89 127.065Z",
    fill: "#CBCCCE"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.79,
    d: "M123.409 127.095C123.417 127.393 123.811 127.84 120.307 127.935C116.802 128.031 113.966 127.866 113.971 127.568C113.977 127.27 116.808 126.575 120.314 126.48C123.818 126.384 123.391 126.37 123.409 127.094V127.095Z",
    fill: "#CACBCD"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M122.928 127.126C122.936 127.407 123.261 127.827 119.957 127.917C116.654 128.007 113.978 127.852 113.983 127.572C113.988 127.29 116.659 126.64 119.962 126.55C123.266 126.46 122.91 126.448 122.927 127.126H122.928Z",
    fill: "#C9CACC"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M122.447 127.155C122.453 127.419 122.711 127.812 119.608 127.897C116.505 127.983 113.992 127.837 113.997 127.574C114.001 127.31 116.51 126.704 119.613 126.619C122.716 126.533 122.431 126.525 122.447 127.155Z",
    fill: "#C8C9CB"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.84,
    d: "M121.967 127.185C121.973 127.432 122.162 127.798 119.26 127.879C116.356 127.959 114.007 127.824 114.011 127.577C114.015 127.33 116.36 126.769 119.264 126.688C122.167 126.608 121.953 126.602 121.968 127.184L121.967 127.185Z",
    fill: "#C7C9CA"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M121.486 127.216C121.492 127.445 121.613 127.784 118.912 127.86C116.209 127.935 114.021 127.81 114.024 127.581C114.027 127.351 116.212 126.834 118.915 126.759C121.617 126.683 121.474 126.68 121.487 127.216H121.486Z",
    fill: "#C6C8C9"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M121.005 127.245C121.011 127.458 121.063 127.77 118.562 127.84C116.06 127.911 114.034 127.795 114.037 127.582C114.04 127.37 116.062 126.898 118.563 126.828C121.065 126.757 120.993 126.757 121.005 127.244V127.245Z",
    fill: "#C5C7C8"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.88,
    d: "M120.524 127.276C120.53 127.472 120.514 127.756 118.213 127.822C115.912 127.888 114.048 127.782 114.05 127.587C114.052 127.39 115.912 126.964 118.213 126.898C119.747 126.854 120.518 126.98 120.524 127.276Z",
    fill: "#C4C6C7"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M120.044 127.305C120.049 127.483 119.965 127.742 117.865 127.802C115.764 127.863 114.062 127.767 114.064 127.588C114.066 127.41 115.764 127.028 117.865 126.967C119.966 126.906 120.035 126.912 120.045 127.304L120.044 127.305Z",
    fill: "#C3C5C6"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M119.563 127.335C119.568 127.497 119.416 127.729 117.516 127.783C115.615 127.839 114.076 127.753 114.077 127.591C114.078 127.43 115.613 127.092 117.514 127.036C119.414 126.981 119.554 126.989 119.563 127.334V127.335Z",
    fill: "#C2C4C6"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.93,
    d: "M119.082 127.366C119.086 127.51 118.866 127.715 117.166 127.765C115.467 127.816 114.09 127.739 114.09 127.595C114.09 127.451 115.464 127.158 117.163 127.107C118.863 127.056 119.074 127.068 119.082 127.366Z",
    fill: "#C1C3C5"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.94,
    d: "M118.602 127.395C118.606 127.523 118.317 127.7 116.817 127.745C115.318 127.791 114.103 127.725 114.103 127.597C114.103 127.47 115.314 127.222 116.813 127.177C118.312 127.131 118.595 127.146 118.601 127.395H118.602Z",
    fill: "#C0C2C4"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.96,
    d: "M118.122 127.426C118.125 127.536 117.768 127.686 116.469 127.727C115.171 127.768 114.117 127.711 114.117 127.601C114.117 127.49 115.166 127.287 116.465 127.247C117.763 127.206 118.117 127.225 118.123 127.427L118.122 127.426Z",
    fill: "#BFC1C3"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.97,
    d: "M117.64 127.456C117.643 127.549 117.217 127.673 116.119 127.708C115.021 127.744 114.13 127.697 114.129 127.604C114.128 127.511 115.015 127.352 116.113 127.317C117.21 127.281 117.635 127.302 117.64 127.456Z",
    fill: "#BEC0C2"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    d: "M117.161 127.485C117.164 127.562 116.669 127.658 115.771 127.688C114.874 127.719 114.146 127.682 114.144 127.606C114.142 127.53 114.867 127.416 115.764 127.385C116.661 127.355 117.157 127.379 117.161 127.485Z",
    fill: "#BDBFC1"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M116.68 127.516C116.682 127.575 116.119 127.644 115.422 127.67C114.726 127.695 114.158 127.669 114.156 127.61C114.154 127.551 114.717 127.481 115.414 127.456C116.111 127.43 116.678 127.457 116.68 127.516Z",
    fill: "#BCBEC0"
  }))), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M141.533 88.654L144.677 86.3358C144.929 86.1504 145.283 86.2033 145.469 86.454L149.519 91.9109C149.705 92.1615 149.652 92.5153 149.4 92.7007L146.256 95.0189L141.534 88.6548L141.533 88.654Z",
    fill: "url(#paint0_linear_60920_3009)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M144.615 95.5674L140.569 90.1143C140.345 89.8133 139.924 89.7456 139.629 89.9633L114.51 108.488L108.368 117.687C108.196 117.944 108.447 118.282 108.743 118.194L119.366 115.031L144.485 96.5067C144.78 96.289 144.838 95.8684 144.615 95.5674Z",
    fill: "url(#paint1_linear_60920_3009)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M144.615 95.5674L140.568 90.1143C140.345 89.8133 139.924 89.7456 139.629 89.9633L114.51 108.488C115.1 108.052 115.941 108.187 116.388 108.789C116.835 109.391 116.719 110.233 116.129 110.668C116.719 110.233 117.56 110.368 118.007 110.97C118.454 111.572 118.338 112.413 117.748 112.848C118.338 112.413 119.179 112.548 119.626 113.15C120.073 113.752 119.957 114.594 119.366 115.029L144.486 96.5047C144.781 96.287 144.839 95.8664 144.616 95.5654L144.615 95.5674Z",
    fill: "#FFCD00"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M116.128 110.668C116.718 110.233 117.559 110.368 118.006 110.97C118.416 111.522 118.348 112.27 117.881 112.727L143.389 93.9163L141.771 91.7348L116.262 110.545C116.218 110.587 116.177 110.631 116.128 110.667V110.668Z",
    fill: "url(#paint2_linear_60920_3009)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M119.343 115C119.933 114.565 120.05 113.724 119.603 113.122C119.194 112.57 118.456 112.416 117.881 112.728L143.39 93.9172L145.009 96.0987L119.5 114.909C119.447 114.938 119.394 114.965 119.343 115.001V115Z",
    fill: "url(#paint3_linear_60920_3009)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M112.116 115.291L110.985 113.766L108.367 117.687C108.22 117.907 108.385 118.186 108.622 118.205C108.625 118.205 108.628 118.207 108.632 118.207C108.668 118.209 108.706 118.205 108.744 118.194L113.27 116.846L112.117 115.291H112.116Z",
    fill: "url(#paint4_linear_60920_3009)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M144.116 90.0436L142.49 87.8523L140.161 89.5699L141.787 91.7612L144.116 90.0436Z",
    fill: "url(#paint5_linear_60920_3009)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M147.335 94.3809L145.662 92.1265L143.333 93.8442L145.005 96.0985L147.335 94.3809Z",
    fill: "url(#paint6_linear_60920_3009)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M145.715 92.1995L144.097 90.0184L141.767 91.7361L143.386 93.9171L145.715 92.1995Z",
    fill: "url(#paint7_linear_60920_3009)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M114.509 108.487C115.099 108.051 115.94 108.187 116.387 108.789C116.796 109.341 116.729 110.089 116.261 110.545L141.77 91.735L140.151 89.5535L114.643 108.364C114.599 108.406 114.558 108.449 114.509 108.486V108.487Z",
    fill: "url(#paint8_linear_60920_3009)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M131.19 163.129C144.54 163.129 155.363 152.355 155.363 139.064C155.363 125.774 144.54 115 131.19 115C117.84 115 107.018 125.774 107.018 139.064C107.018 152.355 117.84 163.129 131.19 163.129Z",
    fill: "url(#paint9_radial_60920_3009)"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_60920_3009)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.669 126.783C140.709 123.823 135.893 123.823 132.933 126.783L128.522 131.194C127.752 131.963 127.129 132.945 126.727 134.144C126.72 134.147 126.714 134.15 126.707 134.152C125.793 136.903 126.486 139.894 128.522 141.93C129.131 142.538 129.846 143.039 130.622 143.409L130.908 143.123C131.898 142.133 131.898 140.534 130.908 139.544C129.262 137.898 129.262 135.226 130.908 133.579L135.319 129.168C136.965 127.522 139.637 127.522 141.284 129.168C142.93 130.815 142.93 133.487 141.284 135.133L137.934 138.482C138.381 139.863 138.476 141.325 138.259 142.749C138.612 142.503 138.952 142.237 139.258 141.93L143.669 137.519C146.63 134.559 146.63 129.743 143.669 126.783Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.489 135.965C133.88 135.357 133.165 134.856 132.377 134.498L132.103 134.772C131.113 135.763 131.113 137.361 132.103 138.351C133.749 139.997 133.749 142.67 132.103 144.316C130.709 145.709 129.009 147.409 127.681 148.738C126.035 150.384 123.363 150.384 121.716 148.738C120.07 147.092 120.07 144.42 121.716 142.773L125.077 139.413C124.63 138.032 124.535 136.57 124.752 135.146C124.399 135.392 124.059 135.658 123.752 135.965L119.33 140.388C116.37 143.348 116.37 148.164 119.33 151.124C122.291 154.084 127.106 154.084 130.067 151.124L134.489 146.702C135.258 145.932 135.882 144.95 136.284 143.751C136.291 143.749 136.297 143.745 136.304 143.743C137.218 140.992 136.525 138.002 134.489 135.965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.646 147.894L140.453 146.701C140.123 146.372 139.59 146.372 139.26 146.701C138.93 147.031 138.93 147.565 139.26 147.894L140.453 149.087C140.783 149.417 141.316 149.417 141.646 149.087C141.975 148.758 141.975 148.224 141.646 147.894Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.751 130.001L122.558 128.808C122.229 128.478 121.695 128.478 121.365 128.808C121.036 129.138 121.036 129.671 121.365 130.001L122.558 131.194C122.888 131.523 123.422 131.523 123.751 131.194C124.081 130.864 124.081 130.33 123.751 130.001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.76 141.626L143.13 141.189C142.68 141.068 142.218 141.335 142.097 141.785C141.977 142.238 142.246 142.699 142.694 142.819L144.323 143.256C144.774 143.376 145.236 143.109 145.357 142.659C145.476 142.209 145.21 141.744 144.76 141.626Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.319 135.076L118.689 134.64C118.239 134.519 117.776 134.786 117.656 135.236C117.535 135.689 117.805 136.15 118.252 136.269L119.882 136.706C120.332 136.827 120.795 136.56 120.915 136.11C121.035 135.659 120.767 135.194 120.319 135.076Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.813 151.765L135.377 150.136C135.255 149.684 134.793 149.419 134.343 149.539C133.893 149.66 133.626 150.122 133.747 150.573L134.184 152.202C134.303 152.65 134.764 152.919 135.217 152.799C135.667 152.678 135.934 152.216 135.813 151.765Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.265 127.322L128.828 125.693C128.708 125.241 128.245 124.977 127.794 125.096C127.344 125.217 127.077 125.679 127.198 126.13L127.635 127.759C127.674 127.907 127.751 128.035 127.853 128.137C128.059 128.343 128.366 128.436 128.668 128.356C129.118 128.235 129.385 127.773 129.265 127.322Z",
    fill: "white"
  })))), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M193.97 86.4481C193.742 86.4481 193.556 86.2652 193.553 86.0341C193.553 85.803 193.736 85.6136 193.967 85.6104C194.246 85.6071 194.529 85.6039 194.808 85.6039C195.039 85.6039 195.225 85.7901 195.225 86.0212C195.225 86.2523 195.039 86.4385 194.808 86.4385C194.529 86.4385 194.252 86.4385 193.976 86.4449H193.97V86.4481Z",
    fill: "#4B90DA"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M177.846 110.766C177.618 110.766 177.432 110.583 177.429 110.355C177.426 110.124 177.608 109.932 177.84 109.928C178.119 109.922 178.401 109.919 178.684 109.919C178.915 109.919 179.101 110.105 179.101 110.336C179.101 110.567 178.915 110.753 178.684 110.753C178.408 110.753 178.132 110.753 177.856 110.763C177.856 110.763 177.849 110.763 177.846 110.763V110.766Z",
    fill: "#4B90DA"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.343 30.7184C180.231 30.6928 180.128 30.6221 180.061 30.5194C179.926 30.3076 179.99 30.0283 180.202 29.8935L183.531 27.7975C183.743 27.6626 184.022 27.73 184.157 27.9387C184.291 28.1505 184.227 28.4298 184.015 28.5646L180.687 30.6607C180.581 30.7281 180.459 30.7441 180.343 30.7184Z",
    fill: "#4B90DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.539 29.7683C178.344 29.7234 178.196 29.5532 178.186 29.3446L178.036 25.4189C178.026 25.1686 178.218 24.9567 178.472 24.9471C178.716 24.9471 178.934 25.1333 178.941 25.3836L179.092 29.3093C179.101 29.5597 178.909 29.7683 178.658 29.7779C178.616 29.7779 178.578 29.7779 178.539 29.7683Z",
    fill: "#4B90DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.816 30.8532C176.777 30.8436 176.742 30.834 176.707 30.8147L173.231 28.9851C173.009 28.8663 172.926 28.5935 173.041 28.372C173.157 28.1505 173.433 28.0735 173.651 28.1794L177.127 30.0123C177.349 30.131 177.435 30.4039 177.317 30.6253C177.22 30.8115 177.012 30.8982 176.816 30.8564V30.8532Z",
    fill: "#4B90DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.568 34.9875C173.456 34.9618 173.353 34.8944 173.285 34.7885C173.151 34.5767 173.215 34.2974 173.427 34.1626L176.752 32.0665C176.964 31.9317 177.243 31.9959 177.378 32.2078C177.513 32.4196 177.449 32.6989 177.237 32.8337L173.911 34.9297C173.805 34.9972 173.684 35.0132 173.571 34.9875H173.568Z",
    fill: "#4B90DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.851 37.7705C178.655 37.7256 178.508 37.5554 178.498 37.3468L178.347 33.4211C178.337 33.1708 178.53 32.9621 178.784 32.9493C179.031 32.9493 179.243 33.1355 179.252 33.3858L179.403 37.3115C179.413 37.5619 179.217 37.7705 178.967 37.7801C178.928 37.7801 178.886 37.7801 178.848 37.7705H178.851Z",
    fill: "#4B90DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.9 34.5863C183.862 34.5767 183.826 34.5638 183.788 34.5446L180.315 32.7117C180.09 32.5962 180.006 32.3233 180.125 32.0986C180.241 31.8772 180.523 31.8001 180.735 31.9093L184.208 33.7389C184.43 33.8576 184.516 34.1305 184.398 34.352C184.301 34.5381 184.093 34.628 183.897 34.5831L183.9 34.5863Z",
    fill: "#4B90DA"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.35408 92.8583C7.24173 92.8326 7.13902 92.762 7.07161 92.6593C6.9368 92.4474 7.00099 92.1681 7.21284 92.0333L10.5415 89.9373C10.7533 89.8025 11.0326 89.8699 11.1674 90.0785C11.3022 90.2904 11.238 90.5696 11.0262 90.7044L7.69754 92.8005C7.59161 92.8679 7.46964 92.8839 7.35408 92.8583Z",
    fill: "#4B90DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5502 91.9081C5.35439 91.8632 5.20674 91.6931 5.19711 91.4844L5.04624 87.5588C5.03661 87.3084 5.22921 87.0965 5.48279 87.0869C5.72674 87.0869 5.94501 87.2731 5.95143 87.5235L6.10229 91.4491C6.11192 91.6995 5.91933 91.9081 5.66896 91.9178C5.62723 91.9178 5.58871 91.9178 5.5502 91.9081Z",
    fill: "#4B90DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.82673 92.9931C3.78821 92.9834 3.7529 92.9706 3.7176 92.9546L0.241305 91.1249C0.0198247 91.0062 -0.0636306 90.7333 0.0519246 90.5118C0.16748 90.2904 0.443526 90.2133 0.661797 90.3193L4.13809 92.1521C4.35957 92.2709 4.44302 92.5437 4.32747 92.7652C4.23117 92.9514 4.02253 93.038 3.82673 92.9963V92.9931Z",
    fill: "#4B90DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.578689 97.1274C0.466344 97.1017 0.363627 97.0343 0.296219 96.9252C0.161405 96.7133 0.225603 96.4341 0.437454 96.2992L3.76288 94.2032C3.97473 94.0684 4.25399 94.1326 4.3888 94.3444C4.52362 94.5563 4.45942 94.8356 4.24757 94.9704L0.922142 97.0664C0.816217 97.1338 0.694243 97.1499 0.581897 97.1242L0.578689 97.1274Z",
    fill: "#4B90DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.86172 99.9103C5.66592 99.8654 5.51826 99.6953 5.50863 99.4866L5.35777 95.561C5.34814 95.3106 5.54073 95.102 5.7943 95.0891C6.04146 95.0891 6.25332 95.2753 6.26295 95.5256L6.41382 99.4513C6.42345 99.7017 6.22764 99.9103 5.97727 99.92C5.93875 99.92 5.89702 99.92 5.85851 99.9103H5.86172Z",
    fill: "#4B90DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9108 96.7294C10.8723 96.7197 10.837 96.7069 10.7985 96.6876L7.32538 94.8548C7.10069 94.7392 7.01724 94.4664 7.136 94.2417C7.25156 94.0202 7.53081 93.9432 7.74587 94.0523L11.219 95.882C11.4404 96.0007 11.5271 96.2736 11.4083 96.495C11.312 96.6812 11.1034 96.7711 10.9076 96.7261L10.9108 96.7294Z",
    fill: "#4B90DA"
  }))), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M153.247 75.3227C153.134 75.297 153.032 75.2264 152.964 75.1237C152.829 74.9119 152.894 74.6326 153.105 74.4978L156.434 72.4017C156.646 72.2701 156.925 72.3343 157.06 72.543C157.195 72.7548 157.131 73.0341 156.919 73.1689L153.59 75.2649C153.484 75.3323 153.362 75.3484 153.247 75.3227Z",
    fill: "var(--color-primary-50)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M151.443 74.3726C151.247 74.3277 151.099 74.1575 151.09 73.9489L150.939 70.0232C150.929 69.7729 151.122 69.561 151.375 69.5514C151.619 69.5514 151.838 69.7376 151.844 69.9879L151.995 73.9136C152.005 74.164 151.812 74.3726 151.562 74.3822C151.52 74.3822 151.481 74.3822 151.443 74.3726Z",
    fill: "var(--color-primary-50)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M149.715 75.4608C149.677 75.4512 149.642 75.4415 149.606 75.4223L146.13 73.5926C145.909 73.4739 145.825 73.201 145.941 72.9796C146.056 72.7581 146.332 72.681 146.55 72.787L150.027 74.6198C150.248 74.7386 150.332 75.0114 150.216 75.2329C150.12 75.4191 149.911 75.5057 149.715 75.464V75.4608Z",
    fill: "var(--color-primary-50)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M146.47 79.5919C146.358 79.5662 146.255 79.4988 146.188 79.3897C146.053 79.1778 146.117 78.8985 146.329 78.7637L149.654 76.6677C149.866 76.5329 150.146 76.5971 150.28 76.8089C150.415 77.0208 150.351 77.3 150.139 77.4348L146.814 79.5309C146.708 79.5983 146.586 79.6143 146.474 79.5887L146.47 79.5919Z",
    fill: "var(--color-primary-50)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M151.75 82.3748C151.555 82.3299 151.407 82.1598 151.397 81.9511L151.246 78.0254C151.237 77.7751 151.429 77.5664 151.683 77.5536C151.93 77.5536 152.142 77.7398 152.152 77.9901L152.302 81.9158C152.312 82.1662 152.116 82.3748 151.866 82.3844C151.827 82.3844 151.786 82.3844 151.747 82.3748H151.75Z",
    fill: "var(--color-primary-50)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M156.799 79.1938C156.761 79.1842 156.726 79.1714 156.687 79.1521L153.214 77.3193C152.989 77.2037 152.906 76.9309 153.025 76.7062C153.14 76.4847 153.423 76.4077 153.635 76.5168L157.108 78.3464C157.329 78.4652 157.416 78.738 157.297 78.9595C157.201 79.1457 156.992 79.2356 156.796 79.1906L156.799 79.1938Z",
    fill: "var(--color-primary-50)"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.079 109.784C185.966 109.758 185.864 109.688 185.796 109.582C185.661 109.37 185.726 109.091 185.937 108.956L189.266 106.86C189.478 106.725 189.757 106.792 189.892 107.001C190.027 107.213 189.963 107.492 189.751 107.627L186.422 109.723C186.316 109.79 186.194 109.806 186.079 109.781V109.784Z",
    fill: "#4B90DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.276 108.834C184.08 108.789 183.932 108.619 183.923 108.41L183.772 104.484C183.762 104.234 183.955 104.022 184.208 104.013C184.452 104.013 184.671 104.199 184.677 104.449L184.828 108.375C184.837 108.625 184.645 108.834 184.395 108.843C184.353 108.843 184.314 108.843 184.276 108.834Z",
    fill: "#4B90DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.548 109.919C182.51 109.909 182.475 109.899 182.439 109.88L178.963 108.051C178.741 107.932 178.658 107.659 178.774 107.437C178.889 107.216 179.165 107.139 179.383 107.245L182.86 109.078C183.081 109.196 183.165 109.469 183.049 109.691C182.953 109.877 182.744 109.964 182.548 109.922V109.919Z",
    fill: "#4B90DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.303 114.053C179.191 114.027 179.088 113.96 179.021 113.854C178.886 113.642 178.95 113.363 179.162 113.228L182.487 111.132C182.699 110.997 182.979 111.061 183.113 111.273C183.248 111.485 183.184 111.764 182.972 111.899L179.647 113.995C179.541 114.063 179.419 114.079 179.306 114.053H179.303Z",
    fill: "#4B90DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.583 116.836C184.388 116.791 184.24 116.621 184.23 116.412L184.079 112.487C184.07 112.236 184.262 112.028 184.516 112.015C184.763 112.015 184.975 112.201 184.985 112.451L185.136 116.377C185.145 116.627 184.949 116.836 184.699 116.846C184.66 116.846 184.619 116.846 184.58 116.836H184.583Z",
    fill: "#4B90DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.632 113.652C189.594 113.642 189.559 113.629 189.52 113.61L186.047 111.777C185.822 111.662 185.739 111.389 185.858 111.164C185.973 110.943 186.252 110.866 186.468 110.975L189.941 112.804C190.162 112.923 190.249 113.196 190.13 113.417C190.034 113.604 189.825 113.693 189.629 113.649L189.632 113.652Z",
    fill: "#4B90DA"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.991 84.7052L197.427 80.7281L223.635 82.561L199.991 84.7052Z",
    fill: "#F9A200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.991 91.2276V84.7052L223.635 82.561L199.991 91.2276Z",
    fill: "#F98200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.089 86.6921L203.968 91.5069L223.635 82.561L201.089 86.6921Z",
    fill: "#F9A200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.991 91.2276L201.089 86.6921L203.114 90.0817L199.991 91.2276Z",
    fill: "#E75E22"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.18 30.3525C38.0338 29.091 38.8877 27.8006 39.7447 26.475C31.0074 27.0848 22.2734 24.0323 13.5361 24.6421C21.4164 25.3579 29.2998 29.0557 37.18 30.3525Z",
    fill: "#F9A200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.18 36.875V30.3525C29.2998 29.0557 21.4164 25.358 13.5361 24.6422C21.4164 27.531 29.2998 33.4019 37.18 36.875Z",
    fill: "#F98200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0822 32.2431C35.1225 33.7517 34.1659 35.2251 33.2062 36.6792C26.6484 32.6668 20.0939 27.6209 13.5361 24.6422C21.0504 26.0192 28.5679 30.1086 36.0822 32.2431Z",
    fill: "#F9A200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1798 36.8749C36.8139 35.3374 36.448 33.7934 36.0821 32.2463C35.408 33.3087 34.7307 34.3519 34.0566 35.3855C35.0998 35.9152 36.1398 36.4159 37.1798 36.8749Z",
    fill: "#E75E22"
  }))), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5767 111.328C28.4147 111.328 27.4678 110.381 27.4678 109.219C27.4678 108.057 28.4147 107.11 29.5767 107.11C30.7386 107.11 31.6855 108.057 31.6855 109.219C31.6855 110.381 30.7386 111.328 29.5767 111.328ZM29.5767 107.945C28.8737 107.945 28.3023 108.516 28.3023 109.219C28.3023 109.922 28.8737 110.493 29.5767 110.493C30.2796 110.493 30.851 109.922 30.851 109.219C30.851 108.516 30.2796 107.945 29.5767 107.945Z",
    fill: "#E75E22"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9312 4.21776C81.7692 4.21776 80.8223 3.27085 80.8223 2.10888C80.8223 0.946911 81.7692 0 82.9312 0C84.0931 0 85.04 0.946911 85.04 2.10888C85.04 3.27085 84.0931 4.21776 82.9312 4.21776ZM82.9312 0.834567C82.2282 0.834567 81.6568 1.40592 81.6568 2.10888C81.6568 2.81184 82.2282 3.3832 82.9312 3.3832C83.6341 3.3832 84.2055 2.81184 84.2055 2.10888C84.2055 1.40592 83.6341 0.834567 82.9312 0.834567Z",
    fill: "#E75E22"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M44.3228 87.119C43.1608 87.119 42.2139 86.1721 42.2139 85.0101C42.2139 83.8482 43.1608 82.9012 44.3228 82.9012C45.4847 82.9012 46.4316 83.8482 46.4316 85.0101C46.4316 86.1721 45.4847 87.119 44.3228 87.119ZM44.3228 83.739C43.6198 83.739 43.0484 84.3104 43.0484 85.0133C43.0484 85.7163 43.6198 86.2877 44.3228 86.2877C45.0257 86.2877 45.5971 85.7163 45.5971 85.0133C45.5971 84.3104 45.0257 83.739 44.3228 83.739Z",
    fill: "var(--color-primary)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M178.874 131.704C177.712 131.704 176.765 130.757 176.765 129.595C176.765 128.433 177.712 127.486 178.874 127.486C180.036 127.486 180.986 128.433 180.986 129.595C180.986 130.757 180.039 131.704 178.874 131.704ZM178.874 128.324C178.171 128.324 177.602 128.895 177.602 129.595C177.602 130.295 178.174 130.866 178.874 130.866C179.573 130.866 180.148 130.295 180.148 129.595C180.148 128.895 179.576 128.324 178.874 128.324Z",
    fill: "#232374"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M64.185 27.8745C63.0231 27.8745 62.0762 26.9276 62.0762 25.7656C62.0762 24.6037 63.0231 23.6567 64.185 23.6567C65.347 23.6567 66.2939 24.6037 66.2939 25.7656C66.2939 26.9276 65.347 27.8745 64.185 27.8745ZM64.185 24.4913C63.4821 24.4913 62.9107 25.0627 62.9107 25.7656C62.9107 26.4686 63.4821 27.0399 64.185 27.0399C64.888 27.0399 65.4594 26.4686 65.4594 25.7656C65.4594 25.0627 64.888 24.4913 64.185 24.4913Z",
    fill: "#4B90DA"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M204.809 108.901C203.647 108.901 202.7 107.954 202.7 106.792C202.7 105.63 203.647 104.683 204.809 104.683C205.971 104.683 206.918 105.63 206.918 106.792C206.918 107.954 205.971 108.901 204.809 108.901ZM204.809 105.518C204.106 105.518 203.538 106.089 203.538 106.792C203.538 107.495 204.109 108.067 204.809 108.067C205.509 108.067 206.08 107.495 206.08 106.792C206.08 106.089 205.509 105.518 204.809 105.518Z",
    fill: "#4B90DA"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M9.27392 42.9031C8.11195 42.9031 7.16504 41.9562 7.16504 40.7942C7.16504 39.6322 8.11195 38.6853 9.27392 38.6853C10.4359 38.6853 11.3828 39.6322 11.3828 40.7942C11.3828 41.9562 10.4359 42.9031 9.27392 42.9031ZM9.27392 39.5199C8.57096 39.5199 7.99961 40.0912 7.99961 40.7942C7.99961 41.4971 8.57096 42.0685 9.27392 42.0685C9.97688 42.0685 10.5482 41.4971 10.5482 40.7942C10.5482 40.0912 9.97688 39.5199 9.27392 39.5199Z",
    fill: "#FFBC2D"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M172.987 11.2313C171.825 11.2313 170.878 10.2844 170.878 9.12243C170.878 7.96046 171.825 7.01355 172.987 7.01355C174.149 7.01355 175.099 7.96046 175.099 9.12243C175.099 10.2844 174.152 11.2313 172.987 11.2313ZM172.987 7.85133C172.284 7.85133 171.713 8.42268 171.713 9.12564C171.713 9.8286 172.284 10.4 172.987 10.4C173.69 10.4 174.261 9.8286 174.261 9.12564C174.261 8.42268 173.69 7.85133 172.987 7.85133Z",
    fill: "#FFBC2D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_60920_3009",
    x: 32.8524,
    y: 46.9318,
    width: 139.454,
    height: 139.455,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.68182
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.34091
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_60920_3009"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_60920_3009",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_60920_3009",
    x: 65.1,
    y: 69.3164,
    width: 76.6418,
    height: 88.5836,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_60920_3009"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_60920_3009",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_di_60920_3009",
    x: 58,
    y: 61.2164,
    width: 90.8418,
    height: 102.784,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_60920_3009"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_60920_3009",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 5.49783,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect2_innerShadow_60920_3009"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.5974
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.09957
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_60920_3009"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_60920_3009",
    x: 85.7646,
    y: 88.778,
    width: 34.6357,
    height: 2.25507,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_60920_3009"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_60920_3009",
    x: 85.7646,
    y: 88.778,
    width: 34.6357,
    height: 1.25507,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_60920_3009"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_60920_3009",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_60920_3009",
    x: 85.7646,
    y: 94.1011,
    width: 34.6357,
    height: 2.25507,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_60920_3009"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_60920_3009",
    x: 85.7646,
    y: 94.1011,
    width: 34.6357,
    height: 1.25507,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_60920_3009"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_60920_3009",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_i_60920_3009",
    x: 85.7646,
    y: 98.8326,
    width: 34.6357,
    height: 2.25507,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_60920_3009"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_60920_3009",
    x: 85.7646,
    y: 98.8326,
    width: 34.6357,
    height: 1.25507,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_60920_3009"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_60920_3009",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_i_60920_3009",
    x: 85.7646,
    y: 103.564,
    width: 34.6357,
    height: 2.25507,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_60920_3009"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d_60920_3009",
    x: 85.7646,
    y: 103.564,
    width: 34.6357,
    height: 1.25507,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_60920_3009"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_60920_3009",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_i_60920_3009",
    x: 85.7646,
    y: 108.296,
    width: 34.6357,
    height: 2.25507,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_60920_3009"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_d_60920_3009",
    x: 85.7646,
    y: 108.296,
    width: 34.6357,
    height: 1.25507,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_60920_3009"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_60920_3009",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_i_60920_3009",
    x: 85.7646,
    y: 113.027,
    width: 34.6357,
    height: 2.25507,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_60920_3009"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_d_60920_3009",
    x: 85.7646,
    y: 113.027,
    width: 34.6357,
    height: 1.25507,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_60920_3009"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_60920_3009",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_i_60920_3009",
    x: 85.7646,
    y: 117.759,
    width: 34.6357,
    height: 2.25507,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_60920_3009"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_d_60920_3009",
    x: 85.7646,
    y: 117.759,
    width: 34.6357,
    height: 1.25507,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_60920_3009"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_60920_3009",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_i_60920_3009",
    x: 85.7646,
    y: 122.491,
    width: 34.6357,
    height: 2.25507,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_60920_3009"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_d_60920_3009",
    x: 85.7646,
    y: 122.491,
    width: 34.6357,
    height: 1.25507,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_60920_3009"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_60920_3009",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_i_60920_3009",
    x: 85.7646,
    y: 127.222,
    width: 34.6357,
    height: 2.25507,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_60920_3009"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_d_60920_3009",
    x: 85.7646,
    y: 127.222,
    width: 34.6357,
    height: 1.25507,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_60920_3009"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_60920_3009",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_i_60920_3009",
    x: 85.7646,
    y: 131.954,
    width: 34.6357,
    height: 2.25507,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_60920_3009"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_d_60920_3009",
    x: 85.7646,
    y: 131.954,
    width: 34.6357,
    height: 1.25507,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_60920_3009"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_60920_3009",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_i_60920_3009",
    x: 85.7646,
    y: 136.39,
    width: 23.9785,
    height: 2.25507,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_60920_3009"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter24_d_60920_3009",
    x: 85.7646,
    y: 136.39,
    width: 23.9785,
    height: 1.25507,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_60920_3009"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_60920_3009",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_60920_3009",
    x1: 143.167,
    y1: 87.0544,
    x2: 147.934,
    y2: 93.6072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5170"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A61C5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_60920_3009",
    x1: 127.101,
    y1: 107.2,
    x2: 123.491,
    y2: 102.902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C09779"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#EEDEC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_60920_3009",
    x1: 128.057,
    y1: 100.024,
    x2: 129.777,
    y2: 102.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_60920_3009",
    x1: 132.195,
    y1: 105.574,
    x2: 130.678,
    y2: 103.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_60920_3009",
    x1: 108.577,
    y1: 114.44,
    x2: 110.342,
    y2: 116.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_60920_3009",
    x1: 141.495,
    y1: 88.5956,
    x2: 142.572,
    y2: 90.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#D1D3D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_60920_3009",
    x1: 146.16,
    y1: 95.2377,
    x2: 144.477,
    y2: 92.9198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D6E71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#939598"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_60920_3009",
    x1: 144.499,
    y1: 93.0785,
    x2: 143.07,
    y2: 90.9604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7A9AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#BCBEC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_60920_3009",
    x1: 129.603,
    y1: 101.776,
    x2: 127.432,
    y2: 99.1256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#FFF769"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_60920_3009",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(131.19 139.064) scale(24.1727 24.0645)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FCA841"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#F59A3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#EA813C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#DA5F38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#C63333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BD2031"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_60920_3009"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.7813,
    height: 28.7813,
    fill: "white",
    transform: "translate(117.11 124.563)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotConnectedPlug);
export default __webpack_public_path__ + "static/media/NotConnectedPlug.538fe49c67a2b05febaa43f8df7c65d1.svg";
export { ForwardRef as ReactComponent };